import moment from "moment"

export const truncateText = (text, maxLength = 150) => {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}

export const stripHtml = (html) => {
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-En', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export const formatDateTime = (dateTime) => {
  return moment(dateTime).format('MMMM DD YYYY, h:mm A')
}